import {
  Avatar,
  Box,
  Chip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { getPatientName } from 'routes/Patients/utils';
import { selectedPatientState } from 'state';
import { getDateString } from 'utils';

export function FormBar() {
  const patient = useRecoilValue(selectedPatientState);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const birthDate = patient?.birthDate;
  const identifiers = patient?.identifiers;
  const patientProjectId = patient?.patientProjectId;

  return (
    <Box
      width={isMobile ? '80%' : '100%'}
      display="flex"
      justifyContent={'start'}
      sx={{
        flexWrap: 'wrap',
      }}
    >
      <Box display={'flex'} flexDirection={'row'} ml={1} mt={0}>
        <Chip
          key={patientProjectId}
          label={patientProjectId}
          avatar={<Avatar>{`ID`}</Avatar>}
          sx={{ mr: 1 }}
        />
      </Box>

      <Typography
        fontWeight="bold"
        sx={{ color: 'black' }}
        fontSize={12}
        mt={0.9}
      >
        {patient ? ` ${getPatientName(patient)}` : ''},
      </Typography>

      {!isMobile && birthDate && (
        <Typography
          variant="body1"
          mr={1}
          mt={0.9}
          ml={1}
          sx={{ color: 'black' }}
          fontSize={'12px'}
        >
          {`${t('general.birthDate')}:`}{' '}
          <strong>{getDateString(birthDate)}</strong>
        </Typography>
      )}

      {!isMobile && identifiers && identifiers.length > 0 && (
        <>
          {identifiers.map(identifier => (
            <Typography
              variant="body1"
              mr={2}
              mt={0.9}
              sx={{ color: 'black' }}
              fontSize={'12px'}
            >
              {`${t(`general.idTypes.shortened.${identifier.type}`)}:`}{' '}
              <strong>{identifier.id}</strong>
            </Typography>
          ))}
        </>
      )}
    </Box>
  );
}
